import { YouTube } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Button, Card, Stack, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import PostConditionComponent from './post-condition/post-condition.component';
import PostPreviewComponent from './post-preview.component';
import { useTranslation } from 'react-i18next';

const PostTabComponent = ({
  updateRequestData,
  isOrgConnectedProfilesData = false,
  handleConditionErrors,
  googleMyBusinessConditionRef,
  tiktokConditionRef,
  linkedInConditionRef,
  youtubeConditionRef,
  twitterConditionRef,
  threadsConditionRef,
  instagramConditionRef,
  facebookConditionRef,
  pinterestConditionRef,
  blueskyConditionRef,
  snapchatConditionRef,
  previewRef,
  newPostForm,
  tabValue,
  setTabValue,
  isShowOfferBanner=false ,
}) => {
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const { t: translate } = useTranslation();

  //State Variable
  useEffect(() => {
    handleUpdateNewFormData();
  }, [tabValue]);
  const [height, setHeight] = useState(window.innerHeight - 280);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleUpdateNewFormData = () => {
    let newFormData = { ...newPostForm };
    let facebookRequestData = newFormData.scheduled_event_requests_data.facebook_requests_data;
    let instagramRequestData = newFormData.scheduled_event_requests_data.instagram_requests_data;
    let youtubeRequestData = newFormData.scheduled_event_requests_data.youtube_requests_data;
    let twitterRequestData = newFormData.scheduled_event_requests_data.twitter_requests_data;
    let threadsRequestData = newFormData.scheduled_event_requests_data.threads_requests_data;
    let linkedinRequestData = newFormData.scheduled_event_requests_data.linkedin_requests_data;
    let gbusinessRequestData = newFormData.scheduled_event_requests_data.gbusiness_requests_data;
    let pinterestRequestData = newFormData.scheduled_event_requests_data.pinterest_requests_data;
    let tiktokRequestsData = newFormData.scheduled_event_requests_data.tiktok_requests_data;
    let blueskyRequestsData = newFormData.scheduled_event_requests_data.bluesky_requests_data;
    let snapchatRequestsData = newFormData.scheduled_event_requests_data.snapchat_requests_data;
    if (facebookRequestData?.length > 0) {
      if (facebookConditionRef && facebookConditionRef.current) {
        facebookConditionRef.current.handleRequestData(facebookRequestData);
      }
    }
    if (instagramRequestData?.length > 0) {
      if (instagramConditionRef && instagramConditionRef.current) {
        instagramConditionRef.current.handleRequestData(instagramRequestData);
      }
    }
    if (youtubeRequestData?.length > 0) {
      if (youtubeConditionRef && youtubeConditionRef.current) {
        youtubeConditionRef.current.handleRequestData(youtubeRequestData);
      }
    }
    if (twitterRequestData?.length > 0) {
      if (twitterConditionRef && twitterConditionRef.current) {
        twitterConditionRef.current.handleRequestData(twitterRequestData);
      }
    }
    if (threadsRequestData?.length > 0) {
      if (threadsConditionRef && threadsConditionRef.current) {
        threadsConditionRef.current.handleRequestData(threadsRequestData);
      }
    }
    if (linkedinRequestData?.length > 0) {
      if (linkedInConditionRef && linkedInConditionRef.current) {
        linkedInConditionRef.current.handleRequestData(linkedinRequestData);
      }
    }
    if (gbusinessRequestData?.length > 0) {
      if (googleMyBusinessConditionRef && googleMyBusinessConditionRef.current) {
        googleMyBusinessConditionRef.current.handleRequestData(gbusinessRequestData);
      }
    }
    if (pinterestRequestData?.length > 0) {
      if (pinterestConditionRef && pinterestConditionRef.current) {
        pinterestConditionRef.current.handleRequestData(pinterestRequestData);
      }
    }
    if (tiktokRequestsData?.length > 0) {
      if (tiktokConditionRef && tiktokConditionRef.current) {
        tiktokConditionRef.current.handleRequestData(tiktokRequestsData);
      }
    }
    if (blueskyRequestsData?.length > 0) {
      if (blueskyConditionRef && blueskyConditionRef.current) {
        blueskyConditionRef.current.handleRequestData(blueskyRequestsData);
      }
    }
    if (snapchatRequestsData?.length > 0) {
      if (snapchatConditionRef && snapchatConditionRef.current) {
        snapchatConditionRef.current.handleRequestData(snapchatRequestsData);
      }
    }

    //Preview Ref
    if (previewRef && previewRef.current) {
      let fData = JSON.parse(JSON.stringify(newFormData));
      previewRef.current.handlePreviewData(fData);
    }
  };
  return (
    <Card sx={{ p: 1, height: isShowOfferBanner ? 'calc(100vh - 263px)' : 'calc(100vh - 213px)' }}>
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <TabList onChange={handleChangeTab}>
              <Tab iconPosition="start" label={translate('post_tab.conditions', 'Conditions')} value={1} />
              <Tab iconPosition="start" label={translate('post_tab.preview', 'Preview')} value={2} />
            </TabList>
            {(!isCustomDomain || isPortalAdmin)&& <Button
              variant="outlined"
              startIcon={<YouTube />}
              onClick={() =>
                window.open('https://www.youtube.com/watch?v=yrqc0X2oz0A&ab_channel=Brand2Social', '_blank')
              }
              color="primary"
            >
              {translate('common.tutorial', 'Tutorial')}
            </Button>}
          </Stack>
        </Box>
        <TabPanel value={1} sx={{ height: isShowOfferBanner ? 'calc(100vh - 300px)' : 'calc(100vh - 250px)' , overflow: 'auto' }}>
          <PostConditionComponent
            updateRequestData={updateRequestData}
            isOrgConnectedProfilesData={isOrgConnectedProfilesData}
            handleConditionErrors={handleConditionErrors}
            googleMyBusinessConditionRef={googleMyBusinessConditionRef}
            tiktokConditionRef={tiktokConditionRef}
            linkedInConditionRef={linkedInConditionRef}
            youtubeConditionRef={youtubeConditionRef}
            twitterConditionRef={twitterConditionRef}
            threadsConditionRef={threadsConditionRef}
            instagramConditionRef={instagramConditionRef}
            facebookConditionRef={facebookConditionRef}
            pinterestConditionRef={pinterestConditionRef}
            blueskyConditionRef={blueskyConditionRef}
            snapchatConditionRef={snapchatConditionRef}
          />
        </TabPanel>
        <TabPanel value={2} sx={{ maxHeight: height, overflow: 'auto' }}>
          <PostPreviewComponent ref={previewRef} isOrgEvent={isOrgConnectedProfilesData} />
        </TabPanel>
      </TabContext>
    </Card>
  );
};
export default PostTabComponent;
